<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ modalTitle }}
  </div>
  <div class="flx-modal-body">
    <div class="text-lg text-neutral-900 py-2">
      Some of the entities you are trying to paste use names that already exist in the data model.
      Upon pasting, these entities will be renamed to ensure uniqueness:
    </div>
    <div class="p-4 text-md text-neutral-700 font-semibold">
      {{ data.conflictedEntities.join(', ') }}
    </div>
  </div>
  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        data-ts="confirmation-modal-cancel-button"
      >
        Cancel
      </button>
      <button
        (click)="confirm()"
        class="flx-ds primary danger"
        flxButton
        type="submit"
        data-testId="confirmation-modal-confirm-button"
      >
        Proceed
      </button>
    </div>
  </div>
</flx-modal>
